import { defineComponent as _defineComponent } from 'vue'
import {
    Floorplan,
    HouseDesignInterface,
  } from "@/types/HouseDesignInterface";
  import { ref, computed, watch } from "vue";
  import { formatPrice as formatMeters } from "@/helpers/transformation/price";
  import store from "@/store";
  import { UserQuoteSelectionInterface } from "@/types/UserQuoteSelectionInterface";
  import { CustomizeHouseStepsEnum } from "@/enums/CustomizeHouseSteps";
  import { BuilderStepsIds } from "@/enums/BuilderStepsIds";
  import BuilderSliderButtons from "./BuilderSliderButtons.vue";
  import { useIsDesktop } from "@/features/useIsDesktop";
  import { scrollToNextStep } from "@/helpers/builder/scrollToNextStep";
  import HouseFeatures from "@/components/builder/HouseFeatures.vue";
  import BuilderLightboxImages from "./BuilderLightboxImages.vue";

  interface Props {
    houseDesign: HouseDesignInterface;
    isFeaturesHidden?: boolean;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderFloorplans',
  props: {
    houseDesign: {},
    isFeaturesHidden: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const showFloorplan = ref(false);
  const fadeInEffectSlider = ref(false);
  const { isDesktop } = useIsDesktop(990);
  const zoom = ref(1);

  const onButtonClickSlider = () => {
    fadeInEffectSlider.value = !fadeInEffectSlider.value;
  };

  const selectedHouseDesign = computed(() => props.houseDesign);

  const props = __props;

  const isImageModalOpen = ref(false);

  const openImageModal = () => {
    isImageModalOpen.value = true;
  };

  const closeImageModal = () => {
    isImageModalOpen.value = false;
    zoom.value = 1;
  };

  const updateZoom = (value: number) => {
    const newZoom = zoom.value + value;

    if (newZoom >= 1 && newZoom <= 2.6) {
      zoom.value = newZoom;
    }
  };

const __returned__ = { showFloorplan, fadeInEffectSlider, isDesktop, zoom, onButtonClickSlider, selectedHouseDesign, props, isImageModalOpen, openImageModal, closeImageModal, updateZoom, get Floorplan() { return Floorplan }, get HouseDesignInterface() { return HouseDesignInterface }, ref, computed, watch, get formatMeters() { return formatMeters }, get store() { return store }, get UserQuoteSelectionInterface() { return UserQuoteSelectionInterface }, get CustomizeHouseStepsEnum() { return CustomizeHouseStepsEnum }, get BuilderStepsIds() { return BuilderStepsIds }, BuilderSliderButtons, get useIsDesktop() { return useIsDesktop }, get scrollToNextStep() { return scrollToNextStep }, HouseFeatures, BuilderLightboxImages }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})